import _ from 'lodash';
import fetchNetworkOutcomes from './fetchNetworkOutcomes';

export default function fetchNetworkReferralOutcomes(networkId, serviceTypeId, params = {}) {
  return fetchNetworkOutcomes(networkId, serviceTypeId, {
    applicable_states: [_.get(params, 'state') === 'draft' ? 'draft' : 'deferred'],
    ...params,
  });
}
